module.exports = {"510421100":"攀莲镇","510421101":"丙谷镇","510421102":"得石镇","510421103":"撒莲镇","510421104":"垭口镇","510421105":"白马镇","510421106":"普威镇","510421200":"草场乡","510421201":"湾丘彝族乡","510421202":"白坡彝族乡","510421203":"麻陇彝族乡","510421204":"新山傈僳族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510421.json
// module id = 2104
// module chunks = 0